$(document).ready(function() {
  // Initialize Swiper for announcement bar
  if ($(".announcement-bar__slider").length > 0) {
    $(".announcement-bar__slider").each(function() {
      const slider = this;
      const announcementBar = $(this).closest(".announcement-bar");
      const autoplaySpeed = announcementBar.data("autoplay-speed") || 5000;
      const slides = $(this).find(".swiper-slide");
      
      // Only initialize swiper if there are multiple slides
      if (slides.length > 1) {
        new Swiper(slider, {
          loop: true,
          autoplay: {
            delay: autoplaySpeed,
            disableOnInteraction: false,
          },
          speed: 500,
          effect: 'coverflow',
          coverflowEffect: {
            depth: 0,
            rotate: 0
          },
          allowTouchMove: true,
          on: {
            init: function() { 
            }
          }
        });
      }
    });
  }

  // Close button functionality
  if ($(".announcement-bar__close-button").length > 0) {
    let close_btns = $(".announcement-bar__close-button");
    
    close_btns.each((index, close_btn) => {
      let parent_section = $(close_btn).closest(".section-announcement");

      
      $(close_btn).on("click", () => {
				parent_section.hide();
				document.body.classList.add("announcement-hide");
			});
    });
  }
});